module.exports = __webpack_public_path__ + "static/media/velocidad_bco.9aa86567.svg";